import React from 'react';
import PartnersEngagingWithEducators from './PartnersEngagingWithEducators';
import ActivePartners from './ActivePartners';
import PercentPartnersEngagingWithEducators from './PercentPartnersEngagingWithEducators';

export default function PartnersEngagingWithEducatorsGroup(props) {
  return (
    <>
      <PercentPartnersEngagingWithEducators {...props} />
      <PartnersEngagingWithEducators {...props} />
      <ActivePartners {...props} />
    </>
  )
}
